import { Image } from '@/features/shared/elements/Image/NextImage'
import { ButtonLink } from '@/features/shared/elements/Link/Buttons'
import {
  useUserStoreName,
  useStoreId,
  useUserStoreLocationId,
} from '@/features/account/services/User/hooks'
import { Column, Stack } from '@shipt/design-system-layouts'
import { Body } from '@shipt/design-system-typography'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { useUserStoreLocationName } from '@/features/shop/services/ShoppingStore/hooks'
import {
  useIsGuestWithZipOnly,
  useOpenGuestAddressModalForPLA,
} from '@/features/shop/components/ProductDetail/PLA/hooks'
import { Button } from '@shipt/design-system-buttons'
import { objectStorageUrl } from '@/features/shared/utils/objectStorageUrl'
import { ScrollIntoView } from '@/features/shared/components/ScrollIntoView'
import { trackElementViewed } from '@/features/shared/analytics/element'
import { useQueryZeroSearchResultsCMSShelves } from '@/features/cms/services/CMS/queries'
import { LayoutGroup } from '@/features/cms/components/CMS/components/LayoutGroup'
import { getRetailerUrl } from '@shared/constants/routes'

export const ProductNoResultsState = ({
  message,
  productId,
}: {
  message: string
  productId?: string
}) => {
  const storeName = useUserStoreName()
  const storeLocationName = useUserStoreLocationName()
  const isGuestWithZipOnly = useIsGuestWithZipOnly()
  const { data } = useQueryZeroSearchResultsCMSShelves('', !isGuestWithZipOnly)
  const openGuestAddressModalForPLA = useOpenGuestAddressModalForPLA()
  const storeLocationId = useUserStoreLocationId()
  const storeId = useStoreId()

  const fullMessage = `${message} ${storeLocationName}`

  return (
    <Column
      as={ScrollIntoView}
      spacing={{ base: '3xl', md: '4xl' }}
      onInView={() => {
        trackElementViewed({
          content: fullMessage,
          display_sublocation: 'product_unavailable',
          type: 'empty state',
          product_id: productId,
          store_location_id: storeLocationId,
          store_id: storeId,
        })
      }}
    >
      <GridLayoutContainer>
        <Stack margin={[0, 'auto']}>
          <Column justify="center" align="center" flexBasis="350px">
            <Image alt="" width={160} height={160} src={objectStorageUrl('error-search.png')} />
            <Column spacing="xl" align="center">
              <Body align="center" size="xl" strong>
                {fullMessage}
              </Body>
              {isGuestWithZipOnly ? (
                <Button onClick={openGuestAddressModalForPLA}>
                  Change address to view product
                </Button>
              ) : (
                <ButtonLink href={getRetailerUrl(storeName)}>
                  Continue shopping at {storeName}
                </ButtonLink>
              )}
            </Column>
          </Column>
        </Stack>
      </GridLayoutContainer>
      {!!data && <LayoutGroup {...data} />}
    </Column>
  )
}
